import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './SocialMediaApp.vue';
import {routes} from './routes';
import {store} from './store/store';

window.Apps = window.Apps || {};
Apps.initSocialMediaApp = function(glassItemData, initialTranslations) {
  if($('#social-media-app-' + glassItemData.id).length > 0){
    Vue.use(VueRouter);
    const router = new VueRouter({
      routes
    });
    var data = {
      glassItemData,
      initialTranslations
    }
    new Vue({
      el: '#social-media-app-' +glassItemData.id,
      data,
      router,
      store,
      render: h => h(App)
    })
  }
}
